import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { getOutroOuPergunta, getOutroOuResposta } from '../utils-HistoricoMchatRf'
import { HistoricoMChatSimpleVerticalTableItem } from './HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMChatTwoColumnTableItem } from './HistoricoMchatTwoColumnTableItem'

interface HistoricoMchatTwoColumnsEvenlyTableItemProps {
  perguntas: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMchatTwoColumnsEvenlyTableItem = (
  props: Readonly<HistoricoMchatTwoColumnsEvenlyTableItemProps>
) => {
  const { perguntas } = props

  const meio = Math.ceil(perguntas.length / 2)
  const left = perguntas.slice(0, meio)
  const right = perguntas.slice(meio)

  const hasLeft = left && left.length > 0
  const hasRight = right && right.length > 0

  return (
    <HistoricoMChatTwoColumnTableItem
      left={
        hasLeft
          ? left.map((aplicacao) => (
              <HistoricoMChatSimpleVerticalTableItem
                pergunta={getOutroOuPergunta(aplicacao)}
                resposta={getOutroOuResposta(aplicacao)}
                key={aplicacao.pergunta}
              />
            ))
          : null
      }
      right={
        hasRight
          ? right.map((aplicacao) => (
              <HistoricoMChatSimpleVerticalTableItem
                pergunta={getOutroOuPergunta(aplicacao)}
                resposta={getOutroOuResposta(aplicacao)}
                key={aplicacao.pergunta}
              />
            ))
          : null
      }
    />
  )
}
